<template lang='pug'>
//- Side-Effect-Page
div(v-if='active' :class='[$style[`cc-side-effect`], subscribeVip === `yes` ? `cc-vip-mode` : ``]')
  //- Desktop Mode
  div(v-if='rwdType === `desktop`' :class='$style[`cc-side-effect-wrap`]')
    div(:class='$style[`cc-side-effect-panel`]')
      EffectSidebar
    div(:class='$style[`cc-side-effect-left`]')
      div(:class='$style[`cc-side-effect-left-wrap`]')
        router-view(:key='`left-${recordTick}`')

    div(:class='$style[`cc-side-effect-right`]')
      div(:class='$style[`cc-side-effect-topper-wrap`]')
        div(:class='$style[`cc-side-effect-container`]' :key='`right-${boardTick}`')
          EffectRecordDetail(
            v-if='sideNavType === `recordDetail`'
            :recordId='$route.query.r'
            @forceRecordReload='detectRecordReload')
          EffectSummary(v-else)


  //- Mobile Mode
  div(v-else :class='$style[`cc-side-effect-wrap`]')
    div(:class='$style[`cc-side-effect-topper-mobile`]')
      div(:class='$style[`cc-side-effect-topper-wrap`]')
        EffectSidebar

    div(v-show='sideNavType === `main`' :class='$style[`cc-side-effect-left`]')
      div(:class='$style[`cc-side-effect-left-wrap`]')
        router-view(:key='`left-${recordTick}`')
        
    div(v-show='sideNavType !== `main`' :class='$style[`cc-side-effect-right`]')
      div(:class='$style[`cc-side-effect-topper-wrap`]')
        div(:key='`right-${boardTick}`' :class='$style[`cc-side-effect-container`]')
          EffectSummary(v-if='sideNavType === `summary`')
          EffectRecordDetail(
            v-else-if='sideNavType === `recordDetail`'
            :recordId='$route.query.r'
            @forceRecordReload='detectRecordReload')

</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import EffectSummary from './EffectSummary';
import EffectConsult from './EffectConsult';
import EffectSidebar from './EffectSidebar';
import EffectBoard from './EffectBoard';
import EffectRecordDetail from './EffectRecordDetail';
import EffectAiDoctor from './EffectAiDoctor';

export default {
  components: {
    EffectSidebar,
    EffectConsult,
    EffectSummary,
    EffectAiDoctor,
    EffectBoard,
    EffectRecordDetail,
  },

  created() {
    if (!this.loginProfile.sideeffect) {
      this.$router.replace({
        name: 'effect-setup',
      }).catch(() => true);
    } else {
      if (this.loginProfile.user_type === 'doctor') {
        this.$router.push({
          name: 'index',
        }).catch(() => true);
        this.changePopBoxStatus({
          active: true,
          include: 'warnNotDoctor',
        });
        return;
      }
  
      if (this.$route.query.r) {
        this.$route.query.r === 'summary' ? this.sideNavType = 'summary' : this.sideNavType = 'recordDetail';
      }
      this.active = true;
    }
  },

  data() {
    return {
      active: false,
      sideNavType: 'main',
      boardTick: 1,
      recordTick: 1,
    };
  },

  methods: {
    ...mapMutations({
      changePopBoxStatus: 'global/POPBOX_STATUS',
    }),

    detectRecordReload() {
      console.log('Detect Reload!!');
      this.recordTick += 1;
    },
  },

  // eslint-disable-next-line vue/order-in-components
  computed: {
    ...mapGetters({
      rwdType: 'global/exportRwdType',
      // loginDjangoId: 'user/exportUserDjangoId',
      loginStatus: 'user/exportLoginStatus',
      loginProfile: 'user/exportUserProfile',
      // stateFlowBarFixed: 'global/exportFlowBarFixed',
      subscribeVip: 'user/exportUserSubscribeVip',
      // authJwtToken: 'user/exportUserJwtToken',
    }),
  },

  // eslint-disable-next-line vue/order-in-components
  watch: {
    $route(to, from) {    
      console.log('route', this.$route);
      
      if (to.name === 'effect-record' && this.$route.query.r && this.$route.query.r !== 'summary') {
        this.sideNavType = 'recordDetail';
        this.boardTick += 1;
      } else if (to.name === 'effect-record' && this.$route.query.r === 'summary') {
        this.sideNavType = 'summary';
      } else {
        this.sideNavType = 'main';
      }
    },

    // rwdType() {
    //   if (this.rwdType === 'desktop' && this.sideNavType === 'main') {
    //     this.sideNavType = 'chat';
    //   }
    // },

    loginStatus() {
      if (this.loginProfile.user_type === 'doctor') {
        this.$router.push({
          name: 'index',
        }).catch(() => true);
        this.changePopBoxStatus({
          active: true,
          include: 'warnNotDoctor',
        });
      }
    },
  },
};
</script>

<style module lang='scss'>
  @import '../../../sass/component/page/sideeffect/effect.scss';
</style>
